module.exports = __webpack_public_path__ + "media/images/icon-h-white-46edd084cf5e4f3106d6e7552629aa59.svg";